module.exports = {"version":"1.12.0","aproVersion":"0.11.0","qotmVersion":1.7,"quoteVersion":"0.4.1","branch":"release/v1.12"}